import _ from "lodash";
import {
  TRANSCRIPT_FOR_ACCOUNT_LEVEL_VIEW_PERMISSION,
  TRANSCRIPT_CAN_MANAGE_TEMPLATES_PERMISSION,
  TRANSCRIPT_FOR_PROGRAMME_LEVEL_VIEW_PERMISSION,
  TRANSCRIPT_FOR_PROGRAMME_CAN_MANAGE_TEMPLATES_PERMISSION,
  TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
  TRANSCRIPT_CAN_MANAGE_TRANSCRIPT_DOWNLOAD_PERMISSION,
} from "Constants/permissionConstants";

export const hasPermission = ({
  permissionMap,
  permission,
  curriculumProgramId,
}) => {
  if (_.isNil(permissionMap)) return false;

  if (_.get(permissionMap, "account", new Set()).has(permission)) {
    return true;
  }

  if (!_.isNil(curriculumProgramId)) {
    return _.get(permissionMap, ["school", curriculumProgramId], new Set()).has(
      permission
    );
  }

  return false;
};

export const hasPermissionInAnySchool = ({ permissionMap, permission }) => {
  const schoolPermissions = _.get(permissionMap, "school", {});
  return _.some(
    schoolPermissions,
    permissions => _.isObject(permissions) && permissions.has(permission)
  );
};

export const getSchoolsWithPermission = ({ permissionMap, permission }) => {
  const schoolPermissions = _.get(permissionMap, "school", {});
  return _.reduce(
    schoolPermissions,
    (result, permissions, curriculumId) => {
      if (_.isObject(permissions) && permissions.has(permission)) {
        result.push(curriculumId);
      }
      return result;
    },
    []
  );
};

export const canAccessAccountTranscripts = ({ permissionMap }) =>
  _.get(permissionMap, "account", new Set()).has(
    TRANSCRIPT_FOR_ACCOUNT_LEVEL_VIEW_PERMISSION
  );

export const canAccessSchoolTranscripts = ({ permissionMap, schoolId }) =>
  _.get(permissionMap, ["school", schoolId], new Set()).has(
    TRANSCRIPT_FOR_PROGRAMME_LEVEL_VIEW_PERMISSION
  );

export const canManageTemplates = ({
  permissionMap,
  isSchoolPortalRoute,
  schoolId,
}) => {
  if (isSchoolPortalRoute) {
    return (
      canAccessSchoolTranscripts({ permissionMap, schoolId }) &&
      hasPermission({
        permissionMap,
        permission: TRANSCRIPT_FOR_PROGRAMME_CAN_MANAGE_TEMPLATES_PERMISSION,
        curriculumProgramId: schoolId,
      })
    );
  }

  return (
    canAccessAccountTranscripts({ permissionMap }) &&
    hasPermission({
      permissionMap,
      permission: TRANSCRIPT_CAN_MANAGE_TEMPLATES_PERMISSION,
    })
  );
};

export const canManageAcademicRecords = ({ permissionMap, schoolId }) => {
  return (
    canAccessSchoolTranscripts({ permissionMap, schoolId }) &&
    hasPermission({
      permissionMap,
      permission: TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
      curriculumProgramId: schoolId,
    })
  );
};

export const canManageDownloads = ({ permissionMap, schoolId }) => {
  return (
    canAccessSchoolTranscripts({ permissionMap, schoolId }) &&
    hasPermission({
      permissionMap,
      permission: TRANSCRIPT_CAN_MANAGE_TRANSCRIPT_DOWNLOAD_PERMISSION,
      curriculumProgramId: schoolId,
    })
  );
};
